module.exports = __webpack_public_path__ + "static/media/logocompact.0663d994.jpg";